import React from "react";
import {observer} from "mobx-react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {LinearProgress, IconButton} from "@mui/material";
import {useStores} from "../../Hooks";
import TruncatedWithTooltip from "../Shared/TruncatedWithTooltip";
import CloseIcon from '@mui/icons-material/Close';

const ProgressLoaderModalWithMassage = observer(() => {
    const {generalStore, aiStudioStore} = useStores();
    const handleCancel = () => {
        aiStudioStore.abortedFiles.add('ABORT ALL')
    };
    return (
        <ConditionalComponent if={generalStore.progressLoaderModalWithMassageState !== null && generalStore.isProgressLoaderModalWithMassage}>
            <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-background-overlay"
                 style={{zIndex: 1299}}>
                <div className="bg-background-normal rounded-lg flex flex-col justify-between p-4 relative"
                     style={{width: '300px', minHeight: '150px'}}>
                    <div
                        onClick={handleCancel}
                        aria-label="Cancel"
                        className="absolute right-2 top-2 flex items-center justify-center cursor-pointer"
                    >
                        < CloseIcon size="small" />
                    </div>
                    <div className="text-center" style={{paddingTop: '16px', paddingBottom: '16px'}}>
                        Progress: {generalStore.progressLoaderModalWithMassageState.value.toFixed(0)}%
                    </div>
                    <LinearProgress
                        color="primary"
                        value={generalStore.progressLoaderModalWithMassageState.value}
                        variant="determinate"
                        style={{margin: '8px 0'}}
                    />
                    <div className="flex flex-col items-center w-full" style={{marginTop: '8px'}}>
                        <div className="font-semibold">Message:</div>
                        <TruncatedWithTooltip className="text-center text-sm truncate" text={generalStore.progressLoaderModalWithMassageState.message} maxWidth="280px"/>
                    </div>
                </div>
            </div>
        </ConditionalComponent>
    );
});

export default ProgressLoaderModalWithMassage;